import {inject, injectable} from 'inversify';

import type {Nullable} from '../../../utils/utility-types';
import type {UserModel} from '../../domain/User/User.model';

import {logger} from '../../../utils/logger';
import {FetchUserQuery} from '../../ports/User/FetchUser/FetchUser.query';
import {CurrentUserService} from '../../system/currentUser/CurrentUser.service';

@injectable()
export class FetchUserUseCase {
  constructor(
    @inject(FetchUserQuery) private readonly query: FetchUserQuery,
    @inject(CurrentUserService)
    private readonly userService: CurrentUserService,
  ) {}

  async exec(props: FetchUserUseCase.Props): Promise<Nullable<UserModel>> {
    try {
      let user: Nullable<UserModel> = null;

      if (props.id === this.userService.id) {
        await this.userService.fetch();

        user = this.userService.user;
      } else {
        user = await this.query.exec(props);
      }

      return user;
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace FetchUserUseCase {
  export type Props = FetchUserQuery.Props;
}
